<template>
  <BaseAttachmentList :loading="false" :attachments="material.attachments">
    <template v-slot:actions>
      <MaterialAttachmentForm
        :id="parseInt(material.id)"
      />
    </template>
  </BaseAttachmentList>
</template>

<script>
import BaseAttachmentList from "../../components/Attachments/BaseAttachmentList";
import MaterialAttachmentForm from "../../components/Attachments/MaterialAttachmentForm";
export default {
  name: "MaterialAttachments",
  components: { BaseAttachmentList, MaterialAttachmentForm },
  props: {
    material: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
